<div class="container" [class.shown]="_showModal" (click)="_close()" (keydown)="_onKeydownCode($event)">
  <div class="modal window" (click)="_captureEvent($event)">
      <div class="header">
          <h1>{{ _title }}</h1>
          <div class="close" (click)="_close()">
            <i class="fas fa-times"></i>
        </div>
      </div>
      <div class="body">
          <ng-template modal-host></ng-template>
      </div>
  </div>
</div>